module.exports = __webpack_public_path__ + "static/media/clinic-case-promo.dfb0a4b0.jpg";